import { Link } from "react-router-dom";
import Logo from "../images/logo/logo.png";
import { useState } from "react";
import { internalWebUrl } from "../config";
import LanguagePopover from "./LanguagePopover";
import { useTranslation } from "react-i18next";

function Navbar() {
  const [nav, setNav] = useState(false);
  const { t } = useTranslation();

  const openNav = () => {
    setNav(!nav);
  };

  return (
    <>
      <nav>
        {/* mobile */}
        <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
          <div onClick={openNav} className="mobile-navbar__close">
            <i className="fa-solid fa-xmark"></i>
          </div>
          <ul className="mobile-navbar__links">
            <li>
              <Link onClick={openNav} to="/">
                {t("home")}
              </Link>
            </li>
            {/* <li>
              <Link onClick={openNav} to="/about">
                About
              </Link>
            </li> */}
            <li>
              <Link onClick={openNav} to="/vehicles">
                {t("vehicles")}
              </Link>
            </li>
            {/* <li>
              <Link onClick={openNav} to="/testimonials">
                Testimonials
              </Link>
            </li> */}
            {/* <li>
              <Link onClick={openNav} to="/team">
                Our Team
              </Link>
            </li> */}
            {/* <li>
              <Link onClick={openNav} to="/contact">
                Contact
              </Link>
            </li> */}
            <LanguagePopover />
            <Link className="sign_in" to={internalWebUrl}>
              {t("sign_in").toUpperCase()}
            </Link>
          </ul>
        </div>

        {/* desktop */}

        <div className="navbar">
          <div className="navbar__img">
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <img src={Logo} alt="logo-img" />
            </Link>
          </div>
          <ul className="navbar__links">
            <li>
              <Link className="home-link" to="/">
                {t("home")}
              </Link>
            </li>
            {/* <li>
              {" "}
              <Link className="about-link" to="/about">
                About
              </Link>
            </li> */}
            <li>
              {" "}
              <Link className="models-link" to="/vehicles">
                {t("vehicles")}
              </Link>
            </li>
            {/* <li>
              {" "}
              <Link className="testi-link" to="/testimonials">
                Testimonials
              </Link>
            </li> */}
            {/* <li>
              {" "}
              <Link className="team-link" to="/team">
                Our Team
              </Link>
            </li> */}
            {/* <li>
              {" "}
              <Link className="contact-link" to="/contact">
                Contact
              </Link>
            </li> */}
          </ul>
          <div className="navbar__buttons">
            {/* <Link className="navbar__buttons__sign-in" to="/">
              Sign In
            </Link> */}
            <LanguagePopover />
            <Link className="navbar__buttons__register" to={internalWebUrl}>
              {t("sign_in").toUpperCase()}
            </Link>
          </div>

          {/* mobile */}
          <div className="mobile-hamb" onClick={openNav}>
            <i className="fa-solid fa-bars"></i>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
